@import '../../styles/buttons.css';

:host {
  display: block;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tambr-slider {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  aspect-ratio: 4 / 3;
}

.tambr-slider #prev-button {
  position: absolute;
  top: 50%;
  left: -10px;
  transform: translateY(-50%);
  z-index: 10;
}

.tambr-slider #next-button {
  position: absolute;
  top: 50%;
  right: -10px;
  transform: translateY(-50%);
  z-index: 10;
}

.tambr-slider-wrapper {
  display: flex;
  align-items: center;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  height: 100%;
  scroll-behavior: smooth;
}

.tambr-slider-wrapper.card {
  border-radius: 10px 10px 0 0;
}

.tambr-slider-wrapper.dialog {
  border-radius: 5px 5px 0 0;
}

.tambr-slider-wrapper::-webkit-scrollbar {
  display: none;
}

.tambr-slider-item {
  flex: 0 0 100%;
  scroll-snap-align: center;
}

.tambr-arrow-button {
  opacity: 1;
  margin: 3px;
  transition: visibility 0.1s ease-in-out, opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

.tambr-arrow-button.visible {
  opacity: 1;
  visibility: visible;
}

.tambr-arrow-button.hidden {
  opacity: 0;
  visibility: hidden;
}

#prev-button.hidden {
  transform: translateX(20%) translateY(-50%);
}

#next-button.hidden {
  transform: translateX(-20%) translateY(-50%);
}